import React from 'react';
import { Icon } from '../icon';
import type { AIChatStep } from './types';
import { AIChatWaveIndicator } from './AIChatWaveIndicator';
import { StepItem, StepList } from './AIChat.Styled';

export type AIChatStepsProps = {
	steps: AIChatStep[];
	assistantAvatarSrc?: string;
};

/**
 * What the assistant is doing while it works: finished steps as a checklist, and the one in
 * progress shimmering underneath, where the loading phrase would otherwise be.
 */
export function AIChatSteps({ steps, assistantAvatarSrc }: AIChatStepsProps): React.ReactElement {
	const finished = steps.filter(step => step.status !== 'running');
	// Read-only tools can run side by side; the newest one speaks for them.
	const current = [...steps].reverse().find(step => step.status === 'running');

	return <>
		{finished.length > 0 && (
			<StepList aria-label="Steps taken">
				{finished.map(step => (
					<StepItem key={step.id} $error={step.status === 'error'}>
						<Icon icon={step.status === 'error' ? 'x' : 'check'} />
						{step.label}
					</StepItem>
				))}
			</StepList>
		)}
		<AIChatWaveIndicator assistantAvatarSrc={assistantAvatarSrc} text={current?.label} />
	</>;
}
